import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAttachment($companyId: ID!, $id: ID!) {
    deleteAttachment(companyId: $companyId, id: $id) {
      attachment {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
